export default {
  en: {
    chat: {
      title: 'Inquiries by chat',
      form_placeholder: 'Please enter your message.',
      form_label: 'Send',
    },
    resetConv: {
      title: 'Asking again from the beginning.',
      form_title: 'You can ask again from the beginning.',
      form_label: 'Send',
    },
    translate: {
      description: 'You can switch languages',
    },
    images: {
      Chatbot: 'Go to the chat screen.',
      Chatbot_alt: 'Character trembling with apology.',
    },
    button: {
      close: 'Close',
      closeAriaLabel: 'Close the chat screen.',
      send: 'Send',
    },
    resetButton: {
      reset: 'Reset',
      resetAriaLabel: 'Ask again from the beginning.',
      send: 'Send',
    },
    maintenance: {
      text: 'The chat service is currently<br/>unavailable.',
      sub: 'We apologize for the inconvenience, but please give it some time and try again.',
    },
    moreMessage: 'There\'s more to the message.',
  },
  ja: {
    chat: {
      // title: 'チャットでのお問い合わせ',
      // title: 'スシローに関するお問合せ',
      title: '京樽／回転寿司みさきに関するお問合せ',
      // title: '杉玉に関するお問合せ',
      form_title: 'メッセージを入力してください',
      form_label: '送信用',
    },
    resetConv: {
      title: 'はじめから質問しなおす',
      form_title: 'はじめから質問をしなおすことができます',
      form_label: '送信用',
    },
    translate: {
      description: '言語を切り替える事ができます',
    },
    images: {
      Chatbot: 'チャット画面へ移動する',
      Chatbot_alt: '震えているキャラクター',
    },
    button: {
      close: '閉じる',
      closeAriaLabel: 'チャット画面を閉じる',
      send: '送信',
    },
    resetButton: {
      reset: 'はじめから',
      resetAriaLabel: 'はじめから質問しなおす',
      send: '送信',
    },
    maintenance: {
      text: '',
      sub: 'ただいまメンテナンス中です。<br/>しばらくたってからアクセスしてください。',
    },
    moreMessage: 'メッセージの続きがあります',
  },
};
